import { ChangeEventHandler, ReactNode } from 'react';
import styles from './form.module.css';

type ICustomCheckBoxProps = {
  appendElement?: ReactNode;
  callback?: ChangeEventHandler<HTMLInputElement>;
  checked?: boolean;
  form?: boolean;
  value?: string;
  label?: ReactNode;
};

export function CustomCheckBox({
  value,
  label,
  callback,
  checked,
  form = false,
  appendElement = undefined,
}: ICustomCheckBoxProps) {
  return (
    <div>
      {appendElement}
      {form ? (
        <input
          className={styles.inputFormCheckBox}
          onChange={callback}
          checked={checked}
          type='checkbox'
          id={value}
        />
      ) : (
        <input
          className={styles.inputCheckBox}
          onChange={callback}
          checked={checked}
          type='checkbox'
          id={value}
        />
      )}
      <label className={styles.labelCheckBox} htmlFor={value}>
        {label}
      </label>
    </div>
  );
}

type IReverseCustomCheckBoxProps = {
  value?: string;
  label: string;
  callback?: ChangeEventHandler<HTMLInputElement>;
  checked?: boolean;
};

export function ReverseCustomCheckBox({
  value,
  label,
  callback,
  checked,
}: IReverseCustomCheckBoxProps) {
  return (
    <div>
      <input
        className={styles.reverseInputCheckBox}
        onChange={callback}
        checked={checked}
        type='checkbox'
        id={value}
      />
      <label
        className={styles.reverseStyledLabelCheckBox}
        htmlFor={value}
        css={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <span dangerouslySetInnerHTML={{ __html: label }} />
      </label>
    </div>
  );
}
